var isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[+-]\d{2}:?\d{2}|Z)?$/;
function isIsoDateString(value) {
    return typeof value === 'string' && isoDateFormat.test(value);
}
export function handleDates(body) {
    if (body === null || typeof body !== 'object') {
        return;
    }
    for (var _i = 0, _a = Object.keys(body); _i < _a.length; _i++) {
        var key = _a[_i];
        // Object.keys handles both arrays and objects. This solution is a trade off between super
        // complicated but type safe and simple however less secure solution. See tests
        // @ts-expect-error
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- see the comment above
        var value = body[key];
        if (isIsoDateString(value)) {
            // @ts-expect-error
            // eslint-disable-next-line no-param-reassign -- see the comment above
            body[key] = new Date(value);
        }
        else if (typeof value === 'object') {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- see the comment above
            handleDates(value);
        }
    }
}
export var applyDateMiddleware = function (axiosInstance) {
    axiosInstance.interceptors.response.use(function (originalResponse) {
        handleDates(originalResponse.data);
        return originalResponse;
    });
};

//# sourceMappingURL=applyDateMiddleware.js.map
